'use client'

import { ActionIcon } from '@mantine/core'
import { RebrandSearchIcon } from '@/components/Icons/Rebrand/SearchIcon'
import { useHeaderSearch } from './HeaderSearchContext'

/** Mobile header control that opens the full-screen header search. */
export function HeaderSearchButton() {
    const { openSearch } = useHeaderSearch()

    return (
        <ActionIcon
            variant="default"
            radius="xl"
            size={44}
            hiddenFrom="sm"
            c="var(--gm-fg-primary-black, #1F1E1D)"
            bd="1px solid var(--gm-foreground-fg-outline-primary, #d1d0cf)"
            __vars={{
                '--ai-bg': 'transparent',
                '--ai-hover': 'var(--gm-bg-highlight-cont, rgba(45, 26, 255, 0.1))',
            }}
            aria-label="Search"
            title="Search"
            data-testid="header-search-button"
            onClick={openSearch}
        >
            <RebrandSearchIcon width={20} height={20} aria-hidden />
        </ActionIcon>
    )
}
